// 結算攤牌的純資料拆分。
// 原 APP：副露使用固定區域、暗牌排在後方、胡牌張獨立留縫。
// 本專案依使用者指定，花牌仍接在整列最後。

import type { THand } from '@core/hand';

/** 將贏家的胡牌張由暗牌拆出；其他家的 winTileId 傳 null。 */
export const splitResultHand = (hand: THand, winTileId: number | null) => {
  if (winTileId === null) {
    return {
      melds: hand.melds,
      concealed: hand.concealed,
      winTile: null,
      flowers: hand.flowers,
    };
  }

  const winIndex = hand.concealed.findIndex((tile) => tile.id === winTileId);
  if (winIndex < 0) {
    return {
      melds: hand.melds,
      concealed: hand.concealed,
      winTile: null,
      flowers: hand.flowers,
    };
  }

  return {
    melds: hand.melds,
    concealed: hand.concealed.filter((_, index) => index !== winIndex),
    winTile: hand.concealed[winIndex] ?? null,
    flowers: hand.flowers,
  };
};
